import React from 'react';
import { Container, Row, Col, Button, FormControl, Tabs, Tab } from 'react-bootstrap';
import ace from 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/worker-javascript';
import AceEditor from 'react-ace';
import { shouldWrapText } from '../util/scriptUtils';
import URLRunSelector from './URLRunSelector';
import { ScriptSchema } from '../services/JobDefinitionService';
ace.config.set('workerPath', '/static/js/src-noconflict');

// This is left over from when Splash was used as the browser emulator
// default offset for reporting script errors to take into account the helper methods inserted by
// the crawler engine when executing the script. This is updated dynamically at runtime to reflect
// the size of the current helper script in the DB
// let firstLineNumber = 1;

class JobDefinitionScriptEditor extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            startUrlValid: true,
            followUpQuestion: ""
        };
        // this.getHelperScriptLength = this.getHelperScriptLength.bind(this);
        this.refreshAceEditor = this.refreshAceEditor.bind(this);
        this.onUrlChange = this.onUrlChange.bind(this);
        this.fetchMarkup = this.fetchMarkup.bind(this);
        this.askFollowUp = this.askFollowUp.bind(this);
        this.updateSchemaKey = this.updateSchemaKey.bind(this);
        this.updateSchema = this.updateSchema.bind(this);
        this.updateHint = this.updateHint.bind(this);
    }
    componentDidMount() {
        // this.getHelperScriptLength()
    }
    refreshAceEditor() {
        /**
         * There's a bug in the ace editor that causes it to not re-render on state change, if
         * it's in a hidden tab. This should trigger it to re-render
         */
        this.aceEditor.editor.resize();
        this.aceEditor.editor.renderer.updateFull();
        this.jobSchemaEditor.editor.resize();
        this.jobSchemaEditor.editor.renderer.updateFull();
        this.dataSchemaEditor.editor.resize();
        this.dataSchemaEditor.editor.renderer.updateFull();
    }
    // getHelperScriptLength() {
    //     // This was necessary when Splash was used as the browser emulator
    //     // but is no longer necessary with Playwright
    //     var url = "/api/v1/helper_script_length/"
    //     $.get(url, res => {
    //         firstLineNumber = res.script_line_count
    //     });
    // }
    onUrlChange(url, siteId, startUrlValid) {
        this.setState({ 
            startUrlValid: startUrlValid
        });
        // Get the current SGR, or create a new one if it doesn't exist
        let sgr = this.props.currentGeneratedScript;
        if (!sgr) {
            sgr = {
                id: null,
                job_definition_id: this.props.currentJobDefinition.id,
                minimized_html_url: url,
                minimized_html_site_id: siteId ? parseInt(siteId) : null,
                schema: new ScriptSchema()
            }
        } else if (sgr.minimized_html_url != url) {
            sgr = { 
                ...sgr,
                minimized_html_url: url,
                minimized_html_site_id: siteId ? parseInt(siteId) : null
            }
        }
        this.props.stateManagementService.updateScriptGenerationRequest(
            this.props.currentJobDefinition, 
            sgr
        );
    }
    fetchMarkup() {
        this.props.fetchMarkup(this.props.currentGeneratedScript);
    }
    askFollowUp() {
        console.log("askFollowUp");
    }
    updateSchemaKey(key) {
        this.props.stateManagementService.updateScriptGenerationRequest(
            this.props.currentJobDefinition, 
            { 
                ...this.props.currentGeneratedScript, 
                schema: new ScriptSchema(
                    this.props.currentGeneratedScript.schema.job, 
                    this.props.currentGeneratedScript.schema.data, 
                    key
                )
            }
        )
        .catch(error => {
            console.error('Failed updating active schema tab:', error);
        });
    }
    updateSchema(schema, type) {
        this.props.stateManagementService.updateScriptGenerationRequest(
            this.props.currentJobDefinition, 
            { 
                ...this.props.currentGeneratedScript, 
                schema: new ScriptSchema(
                    type === 'job' ? schema : this.props.currentGeneratedScript.schema.job, 
                    type === 'data' ? schema : this.props.currentGeneratedScript.schema.data, 
                    this.props.currentGeneratedScript.schema.selectedSchema
                )
            }
        )
        .catch(error => {
            console.error('Failed updating schema editor text:', error);
        });
    }
    updateHint(hint) {
        this.props.stateManagementService.updateScriptGenerationRequest(
            this.props.currentJobDefinition, 
            { ...this.props.currentGeneratedScript, hint: hint }
        )
        .catch(error => {
            console.error('Failed updating hint:', error);
        });
    }
    render() {
        const DEFAULT_SCHEMA_EDITOR_TEXT = "// Now enter the json schema for the data you want to extract";
        const markupFetched = this.props.currentGeneratedScript?.minimized_html_record_id != null;

        return (
            <>
                <Row>
                    <Col md={6}>
                        <Container>
                            <Row>
                                <Col md={12}>
                                    <AceEditor
                                        mode="javascript"
                                        theme="tomorrow"
                                        name="editor"
                                        ref={input => (this.aceEditor = input)}
                                        width="auto"
                                        height="500px"
                                        style={{ "marginTop": "10px" }}
                                        setOptions={{ 
                                            firstLineNumber: 1,
                                            useWorker: true
                                        }}
                                        value={this.props.currentJobDefinition?.script}
                                        wrapEnabled={shouldWrapText(this.props.currentJobDefinition?.script)}
                                        editorProps={{
                                            $blockScrolling: true
                                        }}
                                        onChange={(newValue) => this.props.stateManagementService.updateJobDefinition(
                                            { 
                                                ...this.props.currentJobDefinition, 
                                                script: newValue 
                                            }).catch(error => {
                                                console.error('Failed updating editor text:', error);
                                            })
                                        }
                                    />
                                </Col>
                            </Row>
                            <Row>
                            <Col md={12}>
                                    <Button
                                        className="mb-2 text-end"
                                        variant="success"
                                        onClick={this.props.onJobDefinitionScriptUpdate}
                                    >
                                        Save (Ctrl+S or Cmd+S)
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                    <Col md={6}>
                        <Container>
                            <Row>
                                <Col md={12}>
                                    To generate the script please enter the target URL
                                </Col>
                            </Row>
                            <Row style={{ "marginTop": "10px" }}>
                                <Col md={8}>
                                    <URLRunSelector 
                                        jobDefinition={this.props.currentJobDefinition}
                                        onUrlChange={this.onUrlChange}
                                        runUrl={this.props.currentGeneratedScript?.minimized_html_url}
                                        runSiteId={this.props.currentGeneratedScript?.minimized_html_site_id?.toString()}
                                        startUrlValid={this.state.startUrlValid}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Button variant={markupFetched ? "success" : "light"} onClick={this.fetchMarkup} className="float-end">{markupFetched ? 'Re-fetch Markup' : 'Fetch Markup'}</Button>
                                </Col>
                            </Row>
                            <Row>
                                <Container style={{ display: markupFetched ? 'block' : 'none' }}>
                                    <Row style={{ "marginTop": "10px" }}>
                                        <Col md={12}>
                                            Please select whether this returns job or data, then define the required schema
                                        </Col>
                                    </Row>
                                    <Row style={{ "marginTop": "10px" }}>
                                        <Col md={12}>
                                            <Tabs 
                                                defaultActiveKey="Job" 
                                                className="mb-3"
                                                activeKey={this.props.currentGeneratedScript?.schema?.selectedSchema || 'Job'}
                                                onSelect={(key) => this.updateSchemaKey(key)}
                                            >
                                                <Tab eventKey="Job" title="Job">
                                                    <AceEditor
                                                        mode="javascript"
                                                        theme="tomorrow"
                                                        name="jobEditor"
                                                        ref={input => (this.jobSchemaEditor = input)}
                                                        width="auto"
                                                        height="200px"
                                                        minLines={10}
                                                        maxLines={10}
                                                        style={{ "marginTop": "10px" }}
                                                        setOptions={{ 
                                                            firstLineNumber: 1,
                                                            useWorker: true
                                                        }}
                                                        value={this.props.currentGeneratedScript?.schema?.job}
                                                        wrapEnabled={shouldWrapText(this.props.currentGeneratedScript?.schema?.job)}
                                                        editorProps={{
                                                            $blockScrolling: true
                                                        }}
                                                        placeholder={DEFAULT_SCHEMA_EDITOR_TEXT}
                                                        onChange={(jobSchema) => this.updateSchema(jobSchema, 'job')}
                                                    />
                                                </Tab>
                                                <Tab eventKey="Data" title="Data">
                                                    <AceEditor
                                                        mode="javascript"
                                                        theme="tomorrow"
                                                        name="dataEditor"
                                                        ref={input => (this.dataSchemaEditor = input)}
                                                        width="auto"
                                                        height="200px"
                                                        minLines={10}
                                                        maxLines={10}
                                                        style={{ "marginTop": "10px" }}
                                                        setOptions={{ 
                                                            firstLineNumber: 1,
                                                            useWorker: true
                                                        }}
                                                        value={this.props.currentGeneratedScript?.schema?.data}
                                                        wrapEnabled={shouldWrapText(this.props.currentGeneratedScript?.schema?.data)}
                                                        editorProps={{
                                                            $blockScrolling: true
                                                        }}
                                                        placeholder={DEFAULT_SCHEMA_EDITOR_TEXT}
                                                        onChange={(dataSchema) => this.updateSchema(dataSchema, 'data')}
                                                    />
                                                </Tab>
                                            </Tabs>
                                        </Col>
                                    </Row>
                                    <Row style={{ "marginTop": "10px" }}>
                                        <Col md={9}>
                                            <FormControl
                                                as="textarea"
                                                rows={4}
                                                placeholder="Add any extra guidance to help the script generate"
                                                style={{ width: '100%' }}
                                                value={this.props.currentGeneratedScript?.hint || ''}
                                                onChange={(e) => this.updateHint(e.target.value)}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Button variant="light" className="float-end" onClick={this.props.generateScript}>Generate</Button>
                                        </Col>
                                    </Row>
                                </Container>
                            <Container style={{ display: this.props.currentGeneratedScript?.response ? 'block' : 'none' }}>
                                    <Row style={{ marginTop: '10px' }}>
                                        <Col md={12} className="d-flex align-items-center" >
                                            <FormControl
                                                as="textarea" 
                                                rows={8}
                                                style={{ width: '100%' }}
                                                readOnly
                                                value={this.props.currentGeneratedScript?.response || ''}
                                            />
                                        </Col>
                                    </Row>
                                    <Row style={{ "marginTop": "10px" }}>
                                        <Col md={10}>
                                            <FormControl
                                                type="text"
                                                placeholder="Type your follow-up question here..."
                                                style={{ width: '100%' }}
                                                value={this.state.followUpQuestion}
                                                onChange={(e) => this.setState({ followUpQuestion: e.target.value })}
                                            />
                                        </Col>
                                        <Col md={2} >
                                            <Button variant="light" className="float-end" onClick={this.askFollowUp}>Submit</Button>
                                        </Col>
                                    </Row>
                                </Container>
                            </Row>
                        </Container>
                    </Col>
                    </Row>
                    <Row>
                    <Col md={1} style={{ "height": 10 }}>
                    </Col>
                </Row>
                </>
        );
    }
}

export default JobDefinitionScriptEditor;